/**
 * Task #1976 / #2652 — Custom AI tab (tenant): CRUD endpoint OpenAI-compatible,
 * discovery `/v1/models`, register modelli, probe capability.
 *
 * Wrapper sottile: la UI vive in `@easyflow/ui-frontend` (CustomAIPanel) ed è
 * condivisa con il Master. Qui iniettiamo solo il boundary HTTP tenant
 * (`apiClient` + base `/custom-ai`, in TENANT_AGNOSTIC_PREFIXES).
 */
import apiClient, { formatApiErrorMessage } from '@/lib/api';
import { useToast } from '@/hooks/use-toast';
import { CustomAIPanel } from '@easyflow/ui-frontend';

export default function CustomAITab(): JSX.Element {
  const { toast } = useToast();
  return (
    <CustomAIPanel
      deps={{
        api: apiClient,
        basePath: '/custom-ai',
        notify: (m) => toast(m),
        formatError: (err, fallback) => formatApiErrorMessage(err, fallback),
      }}
    />
  );
}
